import { useEffect, useState, Fragment } from 'react';
import { useRouter } from 'next/router';
import EcoBlogCard from 'eco-design/sections/eco-blog-items/eco-blog-card';
import EcoPagination from 'eco-design/base/eco-pagination';
import { queryCategoryItems } from 'lowcomp/plugins/blog/common/blog-api/queryCategoryItems';
import { getBlogTagFromList } from 'lowcomp/plugins/blog/common/utils';
import BlogTimer from 'lowcomp/plugins/blog/common/blog-timer';
import styles from './index.module.scss';

const PAGE_SIZE = 18;
const INIT_NEWS_CATEGORY_TAGS = ['website-news', 'partnership-news', 'csr-news'];
export default function InstallerNearMe() {
    const { locale = 'us' } = useRouter();
    const [tagActiveKey, setTagActiveKey] = useState('website-news');
    const [total, setTotal] = useState(0);
    const [isShow, setIsShow] = useState(false);

    const [dataListA, setDataListA] = useState<any>([]);
    const [pageActive, setPageActive] = useState(1);

    const getItemsForNone = async (page: number) => {
        const condData: any = {};

        condData.categoryIds = INIT_NEWS_CATEGORY_TAGS;
        // condData.categoryId = 'website-news';
        condData.page = page;
        const dataA = await queryCategoryItems(locale, condData);
        setDataListA(dataA?.items);
        setTotal(dataA?.total);
        setPageActive(page);
    };

    const pageChange = (page: number) => {
        getItemsForNone(page);
    };

    useEffect(() => {
        getItemsForNone(pageActive);
    }, []);

    useEffect(() => {
        if (total <= PAGE_SIZE) {
            setIsShow(false);
        } else {
            setIsShow(true);
        }
    }, [total]);

    return (
        <section className={`${styles['editor-blog-list-all']}`}>
            <div className="editor-blog-list-all-c eco-content">
                {dataListA?.map((item: any, index: number) => {
                    const thePage = JSON.parse(item.thePage || '{}');
                    const tagItem = getBlogTagFromList(item.blogTagList || [], '');

                    return (
                        <Fragment key={index}>
                            <EcoBlogCard
                                label={tagItem.tag}
                                title={thePage.blogTitle}
                                pc={thePage.blogImgPc}
                                h5={thePage.blogImgH5}
                                href={item.seoUrl}
                                categoryHref={undefined}
                                timer={BlogTimer(item.newFirstReleaseTime || item.firstReleaseTime, locale)}
                            />
                        </Fragment>
                    );
                })}
            </div>

            {!!isShow && <EcoPagination total={total} onChange={pageChange} current={pageActive} defaultPageSize={PAGE_SIZE} />}
        </section>
    );
}
